"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PriceSqftSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29,21H11V3a1.0029,1.0029,0,0,0-1-1H3A1.0029,1.0029,0,0,0,2,3V29a1.0029,1.0029,0,0,0,1,1H29a1.0029,1.0029,0,0,0,1-1V22A1.0029,1.0029,0,0,0,29,21ZM9,17.5a.4951.4951,0,0,1-.5.5H7a1,1,0,0,1,0-2H8.5a.4951.4951,0,0,1,.5.5Zm0-5a.4951.4951,0,0,1-.5.5H7a1,1,0,0,1,0-2H8.5a.4951.4951,0,0,1,.5.5Zm0-5a.4951.4951,0,0,1-.5.5H7A1,1,0,0,1,7,6H8.5a.4951.4951,0,0,1,.5.5ZM16,25a1,1,0,0,1-2,0V23.5a.4951.4951,0,0,1,.5-.5h1a.4951.4951,0,0,1,.5.5Zm5,0a1,1,0,0,1-2,0V23.5a.4951.4951,0,0,1,.5-.5h1a.4951.4951,0,0,1,.5.5Zm5,0a1,1,0,0,1-2,0V23.5a.4951.4951,0,0,1,.5-.5h1a.4951.4951,0,0,1,.5.5Z"/><path d="M20.0377,14.5872a2.8821,2.8821,0,0,1-1.9464-.8313,1.347,1.347,0,0,0-.9266-.4187.802.802,0,0,0-.865.8244,1.5777,1.5777,0,0,0,.5952,1.1418,4.0272,4.0272,0,0,0,2.1905.8823v.8857a.9286.9286,0,0,0,1.8572,0v-.9137A2.9486,2.9486,0,0,0,23.7,13.2827c0-1.385-.8383-2.23-2.5406-2.5615l-1.2778-.2629c-.858-.17-1.25-.4941-1.25-1.001,0-.5674.5069-1.02,1.3035-1.02a2.31,2.31,0,0,1,1.7371.7639,1.414,1.414,0,0,0,.98.4186.7513.7513,0,0,0,.7767-.7569,1.6221,1.6221,0,0,0-.58-1.1359,3.7006,3.7006,0,0,0-1.9066-.856V5.9285a.9286.9286,0,0,0-1.8572,0v.9267A2.834,2.834,0,0,0,16.4147,9.627c0,1.3779.8244,2.2569,2.46,2.5952l1.2709.2768c.9731.2093,1.358.5069,1.358,1.0138C21.5039,14.1616,20.99,14.5872,20.0377,14.5872Z"/>';
var PriceSqftSVG = function PriceSqftSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.PriceSqftSVG = PriceSqftSVG;
PriceSqftSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PriceSqftSVG);
exports.default = _default;